<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'MyInvitations',
  computed: {
    ...mapState('user', [
      'invitations',
    ]),
  },
  methods: {
    ...mapActions('user', [
      'fetchInvitations',
    ]),
  },
  created() {
    this.fetchInvitations();
  },
};
</script>
<template>
    <div id="invitations" class="pb-5 bg-white">
        <div class="bg-white pt-5 pb-5">
            <h2 class="text-center">Moje zaproszenia</h2>
        </div>
        <div class="container pt-5">
            <div class="row mb-3">
                <div class="col-12 text-right">
                    <router-link :to="{ name: 'newInvitation'}">
                        Nowe Zaproszenie
                    </router-link>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <table class="table">
                        <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Kod</th>
                            <th scope="col">Aktywowany</th>
                            <th scope="col">Ważny do</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(invitation, index) in invitations" :key="invitation.id">
                            <td>{{ index + 1 }}</td>
                            <td>{{ invitation.code }}</td>
                            <td>{{ invitation.activatedAt }}</td>
                            <td>{{ invitation.expiresAt }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
